<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import type Cleave from "cleave.js";

  import { noop } from "../util/general";
  type CleaveInit =
    | ((ref: HTMLInputElement | null) => Cleave | void)
    | (() => undefined);

  export let label: string | null = null;
  export let value: string = "";
  export let type: string = "text";
  export let cleaveInit: CleaveInit = noop;
  export let cleaveClassIdentifier: string = "";
  export let placeholder: string = "";
  export let isError: boolean = false;

  const handleInput = (event: Event) => {
    if (event.target instanceof HTMLInputElement) {
      value = event.target.value;
    }
  };
  let elementRef: HTMLInputElement | null = null;
  let cleaveInstance: Cleave | void = undefined;
  onMount(() => {
    cleaveInstance = cleaveInit(elementRef);
  });
  onDestroy(() => {
    if (cleaveInstance !== undefined) {
      cleaveInstance.destroy();
    }
  });
</script>

<style>
  #container {
    display: flex;
    width: 100%;
  }
  .label-error {
    color: #be6984;
  }
  #label {
    margin-right: 1em;
  }
  .input-error {
    border: none;
    border-bottom: 1px solid #be6984;
    font-size: 1em;
    width: 100%;
  }
  .input-no-error {
    border: none;
    border-bottom: 1px solid black;
    font-size: 1em;
    width: 100%;
  }
  input:focus {
    outline: none;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }
</style>

<div id="container">
  {#if label}
    <div class:label-error={isError} id="label">{label}</div>
  {/if}
  <input
    {type}
    {value}
    {placeholder}
    class:input-error={isError}
    class:input-no-error={!isError}
    class={cleaveClassIdentifier}
    bind:this={elementRef}
    on:input={handleInput}
    on:change={handleInput} />
</div>
